var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-date-picker',{staticClass:"filter-datetimepicker",attrs:{"format":_vm.format,"showTime":_vm.showTime,"locale":"ru-RU","placeholder":_vm.$t('base.placeholder.selectDate'),"size":"small"},model:{value:(_vm.datetime),callback:function ($$v) {_vm.datetime=$$v},expression:"datetime"}})
}
var staticRenderFns = []

export { render, staticRenderFns }